<template>
	<div>
		<v-data-table
			v-if="hasItens"
			:headers="colunas"
			:items="itens"
			:server-items-length="totalItens"
			item-key="id"
			:options="paginacaoInterna"
			no-data-text="Não há processos de utilização cadastrados"
			hide-default-footer
			:tamanho-maximo-colunas="tamanhoMaximoColunas"
			class="arp-listview row-pointer"
		>
			<template #item.numeroProcesso="{ item }">
				<texto-tooltip
					:texto="formatarValor(item.numeroProcesso)"
					:tamanho-maximo="tamanhoMaximoColunas.numeroProcesso"
				></texto-tooltip>
			</template>

			<template #item.numeroAta="{ item }">
				<texto-tooltip
					:texto="formatarValor(item.numeroAta)"
					:tamanho-maximo="tamanhoMaximoColunas.numeroAta"
				></texto-tooltip>
			</template>

			<template #item.numeroPedido="{ item }">
				<texto-tooltip
					:texto="formatarValor(item.numeroPedido)"
					:tamanho-maximo="tamanhoMaximoColunas.numeroPedido"
				></texto-tooltip>
			</template>

			<template #item.siglaOrgao="{ item }">
				<texto-tooltip
					:texto="formatarValor(item.siglaOrgao)"
					:tamanho-maximo="tamanhoMaximoColunas.siglaOrgao"
				></texto-tooltip>
			</template>

			<template #item.valorTotal="{ item }">
				<texto-tooltip
					:texto="formatarValor(item.valorTotal)"
					:tamanho-maximo="tamanhoMaximoColunas.valorTotal"
				></texto-tooltip>
			</template>

			<template #item.atividadeNome="{ item }">
				<texto-tooltip
					:texto="formatarValor(item.atividadeNome)"
					:tamanho-maximo="tamanhoMaximoColunas.atividadeNome"
				></texto-tooltip>
			</template>

			<template #item.usuarioAtividade="{ item }">
				<texto-tooltip
					:texto="formatarValor(item.usuarioAtividade)"
					:tamanho-maximo="tamanhoMaximoColunas.usuarioAtividade"
				></texto-tooltip>
			</template>

			<template #item.situacaoEntrega="{ item }">
				<span>{{ getSituacaoEntrega(item) }}</span>
			</template>

			<template #item.acoes="{ item }">
				<botao-tooltip
					icone="mdi-login"
					cor="grey"
					texto="Acessar"
					@click="acessarPedido(item)"
				></botao-tooltip>
			</template>
		</v-data-table>
		<paginacao-tabela
			v-if="hasItens"
			:page.sync="paginacaoInterna.page"
			:rows-per-page.sync="paginacaoInterna.rowsPerPage"
			:totalPaginas="totalPaginas"
			:totalItens="totalItens"
			@resetar-page="resetarPage"
		></paginacao-tabela>

		<template-listagem-vazia :textos="textos" :total-itens="totalItens"></template-listagem-vazia>
	</div>
</template>

<script>
import { TabelaColunaUtils } from '@/core/utils'
import tabelaMixin from '@/views/mixins/tabela'
import AtaListagemBotoesAcoes from '@/views/pages/ata/pesquisa/listagem/botoes-acoes/AtaListagemBotoesAcoes.vue'
import { actionTypes, routesNames, tipoAcesso, tipoRecebimento } from '@/core/constants'
import ListagemItens from '@/views/components/ListagemItens.vue'
import TextoTooltip from '@/views/components/TextoTooltip.vue'
import { mapState } from 'vuex'

export default {
	name: 'pedido-aba-listagem',
	components: { TextoTooltip, ListagemItens, AtaListagemBotoesAcoes },
	mixins: [tabelaMixin],
	props: {
		itens: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			tamanhoMaximoColunas: {
				usuarioAtividade: 18,
				atividadeNome: 20,
				siglaOrgao: 20,
				numeroPedido: 20,
				numeroAta: 20,
				numeroProcesso: 20,
				valorTotal: 50,
			},
			paginacaoInterna: this.paginacao,
			textos: {
				titulo: 'Não foram encontrados pedidos.',
			},
		}
	},
	computed: {
		...mapState({
			isIntegracaoRecebimentoEntregaAtivo: (state) => state.parametrosSistema.isIntegracaoRecebimentoEntregaAtivo,
		}),
		colunas() {
			const cols = [
				new TabelaColunaUtils('Ata', 'numeroAta', '10%'),
				new TabelaColunaUtils('Pedido', 'numeroPedido', '15%'),
				new TabelaColunaUtils('Nº Processo', 'numeroProcesso', '10%'),
				new TabelaColunaUtils('Órgão', 'siglaOrgao', '10%'),
				new TabelaColunaUtils('Valor', 'valorTotal', '15%'),
				new TabelaColunaUtils('Data Criação', 'dataCriacao', '10%'),
				new TabelaColunaUtils('Atividade', 'atividadeNome', '10%'),
				new TabelaColunaUtils('Responsável', 'usuarioAtividade', '10%', 'center'),
				new TabelaColunaUtils('Recebido', 'atividadeSituacao', '10%', 'center'),
			]

			if (this.isIntegracaoRecebimentoEntregaAtivo) {
				cols.push(new TabelaColunaUtils('Situação Recebimento', 'situacaoEntrega', '10%'))
			}

			cols.push(new TabelaColunaUtils('Ações', 'acoes', '5%'))

			return cols
		},
	},
	methods: {
		async acessarPedido(item) {
			const informacoesAta = await this.$store.dispatch(actionTypes.ATA.BUSCAR_POR_ID, item.idAta)

			if (!informacoesAta.usuarioPodeVisualizarPedido && !informacoesAta.usuarioPermissaoAlterar) {
				this.mostrarNotificacaoWarning('Usuário sem permissão de acesso.')
			} else {
				this.$router.push({
					name: routesNames.PEDIDO.ACESSAR_ITENS_VIEW,
					params: { id: item.idPedido, tipoAcesso: tipoAcesso.PEDIDO.EDITAR },
					query: { origin: 'PedidoAbaView' },
				})
			}
		},
		resetarPage() {
			this.$emit('resetar-page')
		},
		formatarValor(valor) {
			return valor ? valor : '--'
		},
		getSituacaoEntrega(item) {
			if (item.situacaoEntrega) {
				return tipoRecebimento[item.situacaoEntrega].text
			}

			return '---'
		},
	},
}
</script>

<style scoped lang="stylus">
.pr-tabela-processo-utilizacao-listagem td:hover
	cursor pointer !important

@media (max-width: 720px)
	.pr-tabela-processo-utilizacao-listagem
		td:nth-of-type(1):before
			content "Nº Ata:"

		td:nth-of-type(2):before
			content "Processo:"

		td:nth-of-type(3):before
			content "Descrição:"

		td:nth-of-type(4):before
			content "Órgão Gerenciador:"

		td:nth-of-type(5):before
			content "Situação:"

		td:nth-of-type(6):before
			content "Fim Validade:"

		td:nth-of-type(7):before
			display none
</style>
